import { Easing } from 'motion';

export const EASING_OPTION = {
    EASE_IN_SINE: [0.12, 0, 0.39, 0],
    EASE_IN_CUBIC: [0.32, 0, 0.67, 0],
    EASE_IN_BACK: [0.36, 0, 0.66, -0.56],
    EASE_OUT_SINE: [0.61, 1, 0.88, 1],
    EASE_OUT_CUBIC: [0.33, 1, 0.68, 1],
    EASE_OUT_EXPO: [0.16, 1, 0.3, 1],
    EASE_OUT_BACK: [0.34, 1.56, 0.64, 1],
    EASE_IN_OUT_QUAD: [0.45, 0, 0.55, 1],
} satisfies Record<string, Easing>;
